import React, { useState, useEffect } from "react";
import "./Buy.scss";

const Buy = () => {
  const targetDate = new Date("2025-05-19T22:00:00").getTime(); // Data zakończenia oferty - Rok-Miesiąc-DzieńTGodzina:Minuta:Sekunda

  const calculateTimeLeft = () => {
    const now = new Date().getTime();
    const difference = targetDate - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="buy-div">
      <div className="buy-container">
        {/* <p className="buy-old-price"></p> */}
        <p className="buy-price">
          Zastanawiasz się, kiedy rusza kurs? <br />
          Jaka będzie cena?
        </p>
        <p className="buy-text">
          <strong>
            {/* <span className="buy-old-price">
              Obowiązuje jedynie do 19 maja 2025 (poniedziałek) do 22:00.
            </span> */}
            <br />
            <span className="buy-text">
              Już dziś zapisz się na listę powiadomień - damy znać przed startem
              kolejnej edycji!
              <br />
              <br />
              Kliknij poniżej i wybierz interesujący Cię materiał.
            </span>
            <br />
            {/* <span className="buy-supertext buy-time-left">
              Jeszcze tylko <br />
              {`${timeLeft.days} dni : ${timeLeft.hours} godzin : ${timeLeft.minutes} minut : ${timeLeft.seconds} sekund`}
            </span> */}
          </strong>{" "}
          {/* <br />
          <br />
          Nie czekaj, skorzystaj już dziś! */}
        </p>
        <a className="buy-button" href="https://zapisy.netadminpro.pl">
          Powiadom mnie
        </a>
      </div>
    </div>
  );
};

export default Buy;
